import { upsellingModal } from '@/shared/components/UpsellingModal';
import { type PlanType } from '@/types';

import { type PlanFeatureType } from './consts';
import { useUserPlanManager } from './UserPlanManagerProvider';

export const useUpsellingGuard = () => {
  const { userPlanManager } = useUserPlanManager();

  return <T>(
    action: () => T,
    options: {
      feature: PlanFeatureType;
      from: string;
      initialPlanType?: Exclude<PlanType, 'FREE'>;
      moreConditionForGuard?: boolean;
      onGuard?: () => void;
    },
  ): T | void => {
    const canAccessFeature = userPlanManager.canAccessFeature(options.feature);
    const shouldGuard =
      !canAccessFeature && (options.moreConditionForGuard ?? true);
    if (shouldGuard) {
      if (options.onGuard) {
        options.onGuard();
        return;
      }
      upsellingModal.open({
        initialPlanType:
          options.initialPlanType ??
          userPlanManager.getFeaturePlanType(options.feature),
        from: options.from,
      });
      return;
    }
    return action();
  };
};
